import { getContentId } from 'lib/auth';
/**
 * Generates a gamecast url for a given content object
 * @param {object} content - Destructured an eventId from content
 */

const scoresHost = "http://scores.espn.com";
const mobileHost = "http://m.espn.com";

const leagueCodePathMap = {
    ncaam: 'ncb',
    nba: 'nba',
    nfl: 'nfl',
    ncaaf: 'ncaaf'
};

export default function getMobileGameCastUrlForContent(content, { leagueCode } = {}) {
    const { eventId } = getContentId(content);
    if (eventId && leagueCode) {
        const lowerLeagueCode = leagueCode.toLowerCase();
        if (lowerLeagueCode === 'mlb') {
            return `${mobileHost}/mlb/gamecast?eventId=${eventId}`
        } else if (leagueCodePathMap[lowerLeagueCode]) {
            return `${scoresHost}/${leagueCodePathMap[lowerLeagueCode]}/gamecast?version=mobile&gameId=${eventId}`;
        }
    }
    return null;
}



// WEBPACK FOOTER //
// ./app/lib/format/getMobileGameCastUrlForContent.js